export const AUROFAST_CONSTANTS = {
  AUROFAST_FORGOT_PASSWORD: 'AUROFAST_FORGOT_PASSWORD',
  AUROFAST_ACTIVATE_ACCOUNT: 'AUROFAST_ACTIVATE_ACCOUNT',
  AURODOC_COMPANY_ACTIVATE_ACCOUNT: 'AURODOC_COMPANY_ACTIVATE_ACCOUNT',
  AURODOC_STATUS_ACTIVE: 'ACTIVE',
  AURODOC_STATUS_INACTIVE: 'INACTIVE',
};
